import axios from 'axios';
import { WloCreditoService } from '../types';

import React from 'react';
import toast from 'react-hot-toast';

export class WLOCreditAPIService {
    static avanceRot(avanceRot: {
        ps_ident_cli: any;
        ps_linea_cred: any;
        pn_monto: any;
        pn_plazo: any;
        pn_for_pla: string;
        pn_for_pag: string;
        pn_periodic: string;
        pf_fecha_sol: string;
        ps_estado: string;
    }): any {
        throw new Error('Method not implemented.');
    }

    static async addConyugue(conyugue: Partial<WloCreditoService.ConyugueRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/conyuge', conyugue);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getDocumento(datodocumento: Partial<WloCreditoService.documentoSol>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/documentos-sol/documentofirma', datodocumento);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async getEmail(InfoSend: { id: string; number: string; email: string; typeIdent: string; numbIdent: string }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/emails/estudio', InfoSend);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async consultaCupo(cupo: { Pws_Solicitud: string; Pws_Identificacion: string; Pws_num_Tip_Ident: string }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/consultacupo', cupo);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addCupo(cupo: { Pws_Solicitud: string; Pws_Identificacion: string; Pws_num_Tip_Ident: string }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/creaCupo', cupo);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async registraCupo(body: {
        s_r_ident_cliente: String;
        s_r_lin_cred: string;
        s_r_fec_ini_cupo: String;
        s_r_fec_fin_cupo: string;
        s_r_monto_cupo: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/registrocupo', body);
            return data;
        } catch (e) {
            return returnResponseError(e);
        }
    }

    static async getreferenciacion(referenciacionRequest: Partial<WloCreditoService.referenciacionRequest>) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/referenciacion', referenciacionRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async estadocredito(estadocredito: {
        pws_identificacion: string;
        pws_tip_identificacion: string;
        pws_num_solicitud: string;
        pws_estado: string;
        pws_observacion: string;
        pws_gestor: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/estadocredito', estadocredito);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async EvaluaScore(evaluaScore: {
        ps_radicado: string;
        ps_identificacion: string;
        ps_cod_lin: string;
        ps_tipoCliente: string;
        ps_tip_deucode: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/evaluaScore', evaluaScore);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async addAddress(address: {
        Pws_Tip_Consulta: string;
        Pws_Identificacion: string;
        Pws_Tip_Identificacion: string;
        Pws_Tipo: string;
        Pws_Num_Principal: string;
        Pws_Num_Secundario: string;
        Pws_SufijoPri: string;
        Pws_SufijoSec: string;
        Pws_NumComplementario: string;
        Pws_Complemento1: string;
        Pws_NumComplementario1: string;
        Pws_Complemento2: string;
        Pws_NumComplementario2: string;
        Pws_Barrio: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/operations/adrress', address);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addCodeudor(codeudor: Partial<WloCreditoService.CodeudorRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/codeudor', codeudor);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async grabar_cignus(envio: {
        Pws_Identificacion: string;
        Pws_Tip_Identificacion: string;
        Pws_Tip_Perfil: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/graba-sol-cignus', envio);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addSolicitudPersona(solicitudPersona: Partial<WloCreditoService.SolicitudPersonaRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/person', solicitudPersona);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addSolicitud(solicitud: Partial<WloCreditoService.SolicitudRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/', solicitud);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static extraerListaSolicitudes(consulta: any): any[] {
        const datos = consulta?.payload?.data?.Datos_Sol?.Datos_Sol
            ?? consulta?.payload?.data?.datos_sol?.Datos_Sol;
        if (!datos) return [];
        return Array.isArray(datos) ? datos : [datos];
    }

    static seleccionarSolicitudRecienCreada(consulta: any, preferencias?: { numSol?: string; monto?: string }): any | undefined {
        const lista = WLOCreditAPIService.extraerListaSolicitudes(consulta);
        if (!lista.length) return undefined;
        if (preferencias?.numSol) {
            const exacta = lista.find((item) => String(item.Pws_num_solicitud) === String(preferencias.numSol));
            if (exacta) return exacta;
        }
        const ordenadas = [...lista].sort((a, b) => Number(b.Pws_num_solicitud) - Number(a.Pws_num_solicitud));
        if (preferencias?.monto) {
            const monto = String(Number(preferencias.monto));
            const porMonto = ordenadas.find((item) => String(Number(item.Pws_Val_finan)) === monto);
            if (porMonto) return porMonto;
        }
        return ordenadas[0];
    }

    static persistirNumSolicitud(numSol: string, extra?: Record<string, any>) {
        if (!numSol) return;
        sessionStorage.setItem('wlo_num_solicitud', String(numSol));
        localStorage.setItem('num_solicitud', String(numSol));
        localStorage.setItem('solicitud', JSON.stringify({ solicitudnum: String(numSol), ...(extra || {}) }));
    }
    static async consultaSolicitudCygnusDetal(solicitud: Partial<WloCreditoService.SolicitudDetalla>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/consultadetalle', solicitud);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async consultaSolicitudCygnus(solicitud: Partial<WloCreditoService.SolicitudRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/consulta', solicitud);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static extraerPersonaCygnus(consulta: any): any | undefined {
        const datos = consulta?.payload?.data?.datos_persona?.Datos_persona
            ?? consulta?.payload?.data?.Datos_persona;
        if (!datos) return undefined;
        return Array.isArray(datos) ? datos[0] : datos;
    }

    static extraerCodigoPersonaCygnus(
        consulta?: any,
        personCygnus?: { Pws_i_codigo?: string | number },
        codigoFormulario?: string | number,
    ): string {
        let codigoAlmacenado = '';
        try {
            const stored = localStorage.getItem('person');
            if (stored) {
                const parsed = JSON.parse(stored);
                codigoAlmacenado = parsed?.Pws_i_codigo || parsed?.Pws_I_codigo || parsed?.pws_i_codigo || '';
            }
        } catch {
            codigoAlmacenado = '';
        }
        const personaConsulta = WLOCreditAPIService.extraerPersonaCygnus(consulta);
        const candidatos = [
            personCygnus?.Pws_i_codigo,
            (personCygnus as any)?.Pws_I_codigo,
            codigoFormulario,
            codigoAlmacenado,
            personaConsulta?.Pws_i_codigo,
            personaConsulta?.Pws_I_codigo,
            personaConsulta?.pws_i_codigo,
        ];
        const codigo = candidatos.find((valor) =>
            valor !== undefined && valor !== null && String(valor).trim() !== '' && String(valor) !== '0'
        );
        return codigo !== undefined ? String(codigo) : '';
    }

    static consultaCygnusTienePersona(consulta: any): boolean {
        const result = String(consulta?.payload?.result ?? consulta?.payload?.data?.Resultado ?? '');
        if (result === '-3') return false;
        const persona = WLOCreditAPIService.extraerPersonaCygnus(consulta);
        return Boolean(persona?.Pws_i_codigo || (result === '1' && persona));
    }

    static async obtenerCodigoPersonaCygnus(
        identificacion: string,
        tipoIdentificacion: string,
        personCygnus?: { Pws_i_codigo?: string | number },
        codigoFormulario?: string | number,
    ): Promise<string> {
        const codigoLocal = WLOCreditAPIService.extraerCodigoPersonaCygnus(undefined, personCygnus, codigoFormulario);
        if (codigoLocal) return codigoLocal;
        const consulta = await WLOCreditAPIService.consultaSolicitudCygnus({
            Pws_Identificacion: identificacion,
            Pws_Tip_Identificacion: tipoIdentificacion,
        });
        return WLOCreditAPIService.extraerCodigoPersonaCygnus(consulta, personCygnus, codigoFormulario);
    }
    static async consultaSolicitudListadoCygnus(solicitud: Partial<WloCreditoService.SolicitudListadoRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/consultalistado', solicitud);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async consultaSolicitudANI(
        solicitud: Partial<WloCreditoService.SolicitudRequest>,
        includeApiData?: boolean,
    ): Promise<any> {
        try {
            return await WLOCreditAPIService.consultaANI(
                solicitud.Pws_Identificacion!,
                solicitud.Pws_Tip_Identificacion!,
                includeApiData,
            );
        } catch (e) {
            throw e;
        }
    }

    static readonly ICOD_VALIDACION_ANI_OK = 1;
    static readonly ICOD_VALIDACION_DATO_USUARIO = 2;
    static readonly ICOD_VALIDACION_ERROR_TECNICO = 3;

    static async consultaANI(documento: string, _tipoDocumento: string, includeApiData = false): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/ani/consulta', { documento });
            const payload = data?.payload;

            if (!payload) {
                throw new AniConsultaError(
                    'No fue posible validar el documento en este momento. Puede continuar e ingresar sus datos manualmente en el siguiente paso.',
                    true,
                );
            }

            if (payload.iCodigo === WLOCreditAPIService.ICOD_VALIDACION_ANI_OK && payload.persona) {
                localStorage.setItem('estadoCedula', payload.persona.estadoCedula || '0');
                if (includeApiData) {
                    return { persona: payload.persona, apiData: payload.raw };
                }
                return payload.persona;
            }

            const userMsg = payload.sMsj || 'Por favor verifique los datos ingresados.';
            if (payload.iCodigo === WLOCreditAPIService.ICOD_VALIDACION_ERROR_TECNICO) {
                toast.error(userMsg, { duration: 6000 });
                throw new AniConsultaError(userMsg, true);
            }

            toast.error(userMsg, { duration: 6000 });
            throw new AniConsultaError(userMsg, false);
        } catch (e) {
            if (e instanceof AniConsultaError) {
                throw e;
            }
            const userMsg =
                'No fue posible validar el documento en este momento. Puede continuar e ingresar sus datos manualmente en el siguiente paso.';
            toast.error(userMsg, { duration: 6000 });
            throw new AniConsultaError(userMsg, true);
        }
    }

    static fechaAniToFormIso(fechaExpedicion?: string): string {
        const parts = String(fechaExpedicion ?? '').split('/');
        if (parts.length === 3) {
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
        return fechaExpedicion || '';
    }

    static fechaCygnusToFormIso(fecha?: string): string {
        if (!fecha) return '';
        const raw = String(fecha).trim();
        if (!raw) return '';
        const isoMatch = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            return `${isoMatch[1]}-${isoMatch[2]}-${isoMatch[3]}`;
        }
        if (raw.includes('/')) {
            return WLOCreditAPIService.fechaAniToFormIso(raw);
        }
        return '';
    }

    static fechaFormIsoToDisplay(fecha?: string): string {
        const iso = WLOCreditAPIService.fechaCygnusToFormIso(fecha);
        if (!iso) return '';
        const [year, month, day] = iso.split('-');
        return `${day}/${month}/${year}`;
    }

    static async getListasRestrictivas(listasRest: Partial<WloCreditoService.listaRequest>): Promise<any> {
        try {
            const response = await axios.post(process.env.REACT_APP_API + '/listas/listasRestrictivas', listasRest);
            return response.data;
        } catch (e) {
            throw e;
        }
    }

    static async addPeps(peps: Partial<WloCreditoService.PepsRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/operations/peps', peps);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addReferences(referencias: Partial<WloCreditoService.ReferenciasRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/operations/references', referencias);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async addFinancialInformation(financialInformation: Partial<WloCreditoService.OperacionesFinancierasRequest>): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/operations/financial', financialInformation);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async sendEmailModelo(): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/emails');
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async sendEmailCotizacion(emailInfo: {
        dateSolicitud: string;
        product: string;
        price: string;
        cuotas: string;
        valorCuota: string;
        email: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/emails/cotizacion', emailInfo);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async sendEmailFirmaInicial(emailInfo: { email: string; dateSolicitud: string; numsol: string }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/emails/firma', emailInfo);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async confirmacionEmail(emailInfo: {
        solicitud: string;
        email: string;
        dateSolicitud: string;
        respuesta: boolean;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/emails/confirmacion', emailInfo);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async sendOTP(body: any): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/reg-otp', body);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async verifyCodeRegOtp(body: any): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/reg-otp/verify-code', body);
            return returnResponseSuccess(data);
        } catch (e) {
            return returnResponseError(e);
        }
    }

    static async consultaConsolidada(body: {
        datoConsultar: number;
        tipoDocumento: string;
        numeroSolicitud: number;
        fechaSolicitud: string;
        email: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/auth/consulta-consolidada', body);
            return returnResponseSuccess(data);
        } catch (e) {
            return returnResponseError(e);
        }
    }
    static async consultDataCredito(body: { identificacion: string; primer_apellido: string; tipoIdentificacion: string }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/consultadatacredito', body);
            return returnResponseSuccess(data);
        } catch (e) {
            return returnResponseError(e);
        }
    }
    static async regDataCreditoAndSagrilaft(body: {
        Pws_num_solicitud?: string;
        Pws_Identificacion?: string;
        Pws_Tip_Identificacion?: string;
        Pws_Fec_gen?: string;
        Pws_estado_resotp?: string;
        Pws_Tip_val?: string;
        Pws_Puntaje?: string;
        Pws_Entidad_Consul?: string;
        Pws_Num_cuodat?: string;
    }): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/requests/regDataCredandSagrilaft', body);
            return returnResponseSuccess(data);
        } catch (e) {
            return returnResponseError(e);
        }
    }
    static async addDocuments(body: any): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/documentos-sol', body);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async ConsultarDocumentos(body: any): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/documentos-sol/consultdocumentos', body);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async addReference(): Promise<any> {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/operations/references');
            return data;
        } catch (e) {
            throw e;
        }
    }

    static getTipoDocumentoCygnusToANI(tipoDocumento: string) {
        switch (tipoDocumento) {
            case '13':
                return 'CC';
            case '22':
                return 'CE';
            case '31':
                return 'NIT';
            default:
                return 'CC';
        }
    }

    static async getInventario(inventarioRequest: WloCreditoService.InventarioRequest) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/inventory', inventarioRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async getSimulador(simuladorRequest: Partial<WloCreditoService.SimuladorCreditoRequest>) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/simulador-credito/liq', simuladorRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async createCredito(creaCreditoRequest: Partial<WloCreditoService.creCreditRequest>) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/simulador-credito/crear-credito', creaCreditoRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }
    static async addBank(bankRequest: Partial<WloCreditoService.BankRequest>) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_API + '/admin/cuentas', bankRequest);
            return data;
        } catch (e) {
            throw e;
        }
    }

    static async generarPagare(solicitudPersona: any) {
        try {
            const { data } = await axios.post(process.env.REACT_APP_PINC_API + '/CrearSolicitudPagare', solicitudPersona);
            return data;
        } catch (e) {
            throw e;
        }
    }
}

const returnResponseError = (error: any) => {
    const { response } = error;
    const { data } = response;
    const { errors, message } = data;
    throw { errors, message };
};

const returnResponseSuccess = (response: any) => {
    const { payload, message } = response;
    return { payload, message };
};

/** Error de consulta ANI. allowManual=true permite continuar con captura manual. */
export class AniConsultaError extends Error {
    readonly allowManual: boolean;

    constructor(message: string, allowManual = false) {
        super(message);
        this.name = 'AniConsultaError';
        this.allowManual = allowManual;
        Object.setPrototypeOf(this, AniConsultaError.prototype);
    }
}
